import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { CheckBoxFormControlLabelProps } from "./CheckBoxFormControlLabel";

export type ProjectProgressMapFiltersProps = CheckBoxFormControlLabelProps;

type ProjectProgressFilterContainerProps = {
  children: JSX.Element;
  hasProgressGeoJson: boolean;
  progressLoading: boolean;
};

export const ProjectProgressFilterContainer = React.memo(
  ({
    children,
    hasProgressGeoJson,
    progressLoading,
  }: ProjectProgressFilterContainerProps) => {
    const { t } = useTranslation();
    if (progressLoading) return <Skeleton />;
    if (!hasProgressGeoJson)
      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px",
          }}
        >
          <Typography variant="h6">
            {t("projects:progressNotUploaded")}
          </Typography>
        </Box>
      );

    return <Box>{children}</Box>;
  },
);

ProjectProgressFilterContainer.displayName = "ProjectProgressFilterContainer";
